export default __webpack_public_path__ + "static/media/signIn.786f35b4.png";